<template>
    <div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
               <el-button type="primary" size="mini" round>主要按钮</el-button>
            </td>
            <td>
              <el-input
              clearable
              prefix-icon="el-icon-search"
              suffix-icon="el-icon-date"
              v-model="search"
              size="small"
              @click="searchBoxHandler"
              :placeholder="$t('message.输入关键字')"/>
            </td>
             <td>
               <el-button type="primary" size="mini" round>主要按钮</el-button>
            </td>
        </tr>
        </table>
        <view></view>
      </div>
    </div>
</template>
  <script>
export default {
   data () {
      return {
         // 搜索关键词的历史记录
         historyList: ['a', 'app', 'apple']
      }
     },
     methods: {
         // 点击了模拟的 input 输入框
        searchBoxHandler() {
            // 触发外界通过 @click 绑定的 click 事件处理函数
        this.$emit('click')
        }

     }
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/search/search.vue